import { useRouter } from 'next/router'
import React, { useState, useContext, useCallback, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import { UserContext } from '../../contexts/UserContext'
import EventKit from '../../data/EventKit'

import ButtonRemovePicture from './ButtonRemovePicture'
import CameraIcon from './CameraIcon'
import Spinner from './Spinner'
import UploadIcon from './UploadIcon'

const CIRCLE_BG = `url("data:image/svg+xml,%3Csvg width='144' height='144' viewBox='0 0 144 144' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='72' cy='72' r='70.5' stroke='%23333333' stroke-width='3' stroke-dasharray='6 6'/%3E%3C/svg%3E")`
const PROFILE_PIC = "url(https://scontent-arn2-2.xx.fbcdn.net/v/t1.6435-9/103178517_3222607657763947_2791111641305199921_n.jpg?_nc_cat=100&ccb=1-5&_nc_sid=09cbfe&_nc_ohc=Yme0j2crFtIAX8GrY1h&_nc_ht=scontent-arn2-2.xx&oh=00_AT_-UHoZzRSX0yrgPwEPxPPvJMx8zcEzBh9L8NbJh4MLAQ&oe=61E27EE9)"

export default function ProfilePictureSelector({ token }) {
  const router = useRouter()
  const { event } = router.query
  const [isHovering, setIsHovering] = useState(false)
  const [imageURL, setImageURL] = useState(null)
  const { me, setMe } = useContext(UserContext)
  const [isLoading, setIsLoading] = useState(false)
  const eventKit = new EventKit()


  const onDrop = useCallback(([image]) => {
    if (image) {
      handleUpload(image)
    }
  })

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: 'image/jpeg, image/jpg, image/png', maxFiles: 1 })

  async function handleUpload(image) {
    const formData = new FormData()
    formData.append("profilePicture", image)
    setIsLoading(true)
    eventKit.updateEventUserMe(event, formData, token).then(({ profilePictureSmall }) => {
      setImageURL(profilePictureSmall)
    }).catch(e => console.error(e)).finally(() => {
      setIsLoading(false)
    })
  }

  function handleRemove(e) {
    e.preventDefault()
    const payload = {
      profilePicture: null
    }
    eventKit.updateEventUserMe(event, payload, token).then(({ profilePictureSmall }) => {
      setImageURL(profilePictureSmall)
    }).catch(e => console.error(e))
  }

  function getBackgroundImage() {
    if (imageURL && !isLoading) return `url(${imageURL})`
    if (isHovering) return CIRCLE_BG
    return ""
  }

  useEffect(() => {
    if (me?.profilePictureSmall) {
      setImageURL(me.profilePictureSmall)
    }
  }, [me])

  return (
    <>
      {me && token && (
        <div className={`profile-picture-selector ${(imageURL && !isLoading) ? "has-image" : ""}`} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)} style={{
          backgroundImage: getBackgroundImage()
        }}>
          <div className="profile-picture-selector__inner" {...getRootProps()}>
            <input {...getInputProps()} />
            {isLoading ? (
              <>
                <Spinner />
              </>
            ) : (
              <>
                {!imageURL && (
                  <>
                    {isHovering ? (
                      <>
                        <UploadIcon />
                        <p className="profile-picture-selector__info-text">
                          Drop or Browse
                        </p>
                      </>
                    ) : (
                      <>
                        <CameraIcon />
                        <p className="profile-picture-selector__info-text">
                          Profile Photo
                        </p>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </div>
          {imageURL && (
            <ButtonRemovePicture onClick={handleRemove} />
          )}
        </div>
      )}
    </>
  )
}
